import { SxProps, Theme } from "@mui/material";

export const fieldLabelStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 500,
  marginBottom: "8px",
  color: "#2D3748",
};

export const textFieldStyle: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#CBD5E0",
    },
    "&:hover fieldset": {
      borderColor: "#A0AEC0",
    },
  },
};
